export default "__VITE_ASSET__e33de7b2__"